import { jsx as _jsx } from "react/jsx-runtime";
import { ICONS } from '../../icons/index.js';
import { ModuleFE_CollectionActions } from '@nu-art/thunderstorm-frontend/modules/ModuleFE_CollectionActions';
import { ModuleFE_ConflictResolution } from '@nu-art/conflict-resolution-frontend/_modules/ModuleFE_ConflictResolution';
export const DropDown_DefaultCaret = {
    open: _jsx(ICONS.advisorArrowDown.component, {}),
    close: _jsx(ICONS.advisorArrowDown.component, { className: 'flip' })
};
export const displayEntityDependencies = async (itemKey, itemId) => {
    const response = await ModuleFE_CollectionActions.check.usage({
        dbKey: itemKey,
        itemIds: [itemId]
    }).executeSync();
    if (response.dependencies)
        ModuleFE_ConflictResolution.showDependencies(response.dependencies);
};
//# sourceMappingURL=consts.js.map